import { render, staticRenderFns } from "./ModalHistoricoNotificacoes.vue?vue&type=template&id=1ddbc9d4"
import script from "./ModalHistoricoNotificacoes.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoNotificacoes.vue?vue&type=script&lang=js"
import style0 from "./ModalHistoricoNotificacoes.vue?vue&type=style&index=0&id=1ddbc9d4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports